import { render, staticRenderFns } from "./GridSystem.vue?vue&type=template&id=4462098d"
import script from "./GridSystem.vue?vue&type=script&lang=js"
export * from "./GridSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports